var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 278 112",
    style: {
      enableBackground: "new 0 0 278 112"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_25446",
    className: "st0",
    d: "M4.3,91.6V58.8c0,0,0.6-15,10.8-19.9c0,0-12.5,1.7-14.9-3.9v53.5C0.1,88.5,1.2,91.7,4.3,91.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25447_1_",
    className: "st0",
    d: "M8.3,91.6V59.1c0,0-1-15,13.2-20.7c0,0,7.4-2.8,12.7,2.8c0,0,6.7-10.8,15.6-11.1 c0,0,10.6,0.3,10.5,17c0,0.1,0,0.3,0,0.5c-0.3,17.2,0,28.2,0,28.2s-7-0.8-6.7-7.8V45.8c0,0,0-7.3-7.3-5.9c0,0-6.4,1.9-8.3,10.2 v27.7c0,0-2.2,5.9-7.6,7V51.5c0,0-1.3-5.9-7.8-4.3c0,0-5.7,0.8-7.6,11.8v25C15.2,84,14.9,89.6,8.3,91.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25448_1_",
    className: "st0",
    d: "M0,34.9l28-14.5v2.9L0,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25449_1_",
    className: "st0",
    d: "M6.4,34.9l25.3-12v2.9L6.4,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25450_1_",
    className: "st0",
    d: "M10.5,36.3l26.6-11.8v2.9L10.5,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25451_1_",
    className: "st0",
    d: "M14.5,36.8l27.7-9.7v2.4L14.5,36.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.ddbd404f089209961d6fab55b938da45.svg";
export { ForwardRef as ReactComponent };